import { RectangularSkeletonProps } from "./types";

export const useRectangularSkeleton = ({
  width,
  height,
}: RectangularSkeletonProps) => {
  const computedWidth = typeof width === "string" ? width : `${width}px`;

  const computedHeight = height
    ? typeof height === "string"
      ? height
      : `${height}px`
    : undefined;

  const aspectRatio = height ? undefined : "16/9";

  const style = {
    width: computedWidth,
    height: computedHeight,
    maxWidth: "100%",
    aspectRatio,
  };

  return {
    style,
  };
};
